(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

		document.querySelectorAll('[data-footer-search-trigger]').forEach((link) => {
			if (link.dataset.searchTriggerInitialized === 'true') return;

			link.dataset.searchTriggerInitialized = 'true';
			link.addEventListener('click', (event) => {
				const searchModal = document.querySelector('details-modal.header__search');
				const searchDetails = searchModal?.querySelector('details');
				const searchToggle = searchModal?.querySelector('summary');
				const searchInput = searchModal?.querySelector('input[type="search"]');

				// Keep the link's /search destination as a no-JS/header-disabled fallback.
				if (!searchDetails || !searchToggle) return;

				event.preventDefault();

				if (!searchDetails.open) {
					searchToggle.click();
				} else {
					searchInput?.focus();
				}
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();
